import { SkipToMainContentAnchor } from './styles';

/**
 * Only used in the logged out site. Will only show when the user is tabbing and
 * will be the first in the focus order. #main-content goes to the beginning
 * of the covid banner as decided by design.
 *
 * @returns SkipToMainContentAnchor component
 */
export const SkipToMainContent = ({ id }: { id: string }) => {
  return (
    <SkipToMainContentAnchor href={`#${id}`}>
      <span>Skip to Main Content</span>
    </SkipToMainContentAnchor>
  );
};
